import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="pt-3 border-t border-white/20 flex flex-row justify-center items-center gap-6 text-sm">
      <Link 
        to="/privacy-policy" 
        className="text-black/30 hover:text-black underline transition-colors duration-200"
      >
        {t('footer.privacyPolicy')}
      </Link>
      <Link 
        to="/terms-conditions" 
        className="text-black/30 hover:text-black underline transition-colors duration-200"
      >
        {t('footer.termsConditions')}
      </Link>
      <div className="text-black/30 text-xs">
        © {currentYear} GatherPlay. {t('footer.allRightsReserved')}
      </div>
    </footer>
  );
};

export default Footer;